import React from 'react';
import PropTypes from 'prop-types';

import {
	Wrapper,
	Title,
	Description,
	Divider,
	ColsWrapper,
	IconWrapper,
} from './styles';
import { Tooltip } from 'react-tippy';
import { ApIcon, colors } from '@alixpartners/ui-components';

export class Section extends React.Component {
	static propTypes = {
		title: PropTypes.string.isRequired,
		description: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
		animationIndex: PropTypes.number,
		children: PropTypes.node,
	};

	static defaultProps = {
		animationIndex: 0,
	};

	render() {
		const {
			title,
			description,
			animationIndex,
			children,
			layout,
			tooltipVisible,
			toolTipContent,
			onClickFunc,
			iconName,
			...otherProps
		} = this.props;

		// TODO: fix
		// use 0 animation index because it is currently not passed correctly

		return (
			<Wrapper animationIndex={0} {...otherProps}>
				<Title>
					{title} &nbsp;{tooltipVisible === true && (
						<Tooltip
							position="bottom"
							animation="fade"
							arrow
							html={toolTipContent}
							trigger="mouseenter"
						>
							<IconWrapper>
								<ApIcon
									iconName="baseline_help"
									iconSize={16}
									iconColor={colors.grey6}
								/>
							</IconWrapper>
						</Tooltip>
					)}
					{onClickFunc && (
						<ApIcon
							iconName={iconName}
							iconSize="24px"
							onClick={onClickFunc}
							iconColor={colors.green400}
						/>
					)}
				</Title>
				{layout === 'columns' ? (
					<ColsWrapper>
						{description && <Description>{description}</Description>}

						{children}
					</ColsWrapper>
				) : (
					<React.Fragment>
						{description && <Description>{description}</Description>}
						<Divider />
						{children}
					</React.Fragment>
				)}
			</Wrapper>
		);
	}
}
